module.exports = __webpack_public_path__ + "static/media/strongLogo.b04de9b1.svg";